import React, { useState ,useEffect} from "react";

const ManagerFacilities = () => {
  const [requests, setRequests] = useState([
    { id: 1, employee: "John Doe", facility: "Laptop", status: "Pending" },
    { id: 2, employee: "Jane Smith", facility: "Medical Allowance", status: "Approved" },
  ]);

  const [reports] = useState([
    { employee: "John Doe", facility: "Laptop", month: "Aug 2025", usage: "10 hrs" },
    { employee: "Jane Smith", facility: "Medical Allowance", month: "Aug 2025", usage: "₹5000" },
  ]);

  const handleRecommend = (id) => {
    setRequests((prev) =>
      prev.map((r) => (r.id === id ? { ...r, status: "Recommended" } : r))
    );
  };

  const handleReject = (id) => {
    setRequests((prev) =>
      prev.map((r) => (r.id === id ? { ...r, status: "Rejected" } : r))
    );
  };

// Load Bootstrap dynamically
    useEffect(() => {
        // Bootstrap CSS
        const bootstrapLink = document.createElement("link");
        bootstrapLink.rel = "stylesheet";
        bootstrapLink.href = "https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css";
        bootstrapLink.id = "timesheetgrid-bootstrap";
        document.head.appendChild(bootstrapLink);

        // Bootstrap Icons CSS
        const iconsLink = document.createElement("link");
        iconsLink.rel = "stylesheet";
        iconsLink.href = "https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css";
        iconsLink.id = "timesheetgrid-icons";
        document.head.appendChild(iconsLink);

        return () => {
            const existingBootstrap = document.getElementById("timesheetgrid-bootstrap");
            if (existingBootstrap) existingBootstrap.remove();

            const existingIcons = document.getElementById("timesheetgrid-icons");
            if (existingIcons) existingIcons.remove();
        };
    }, []);



  const getStatusClass = (status) => {
    switch (status) {
      case "Approved":
        return "bg-success";
      case "Rejected":
        return "bg-danger";
      case "Recommended":
        return "bg-info";
      default:
        return "bg-warning text-dark";
    }
  };

  return (
    <div className="container my-4">
      <h2 className="mb-4 text-center fw-bold text-primary">
        👨‍💼 Manager - Employee Facilities
      </h2>

      {/* Requests Section */}
      <div className="card mb-4 shadow-lg border-0 rounded-3">
        <div className="card-header bg-gradient bg-primary text-white fw-bold fs-5">
          📋 Team Requests
        </div>
        <div className="card-body">
          <table className="table table-bordered table-hover table-responsive align-middle text-center">
            <thead className="table-light">
              <tr>
                <th>Employee</th>
                <th>Facility</th>
                <th>Status</th>
                <th style={{ width: "200px" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {requests.map((req) => (
                <tr key={req.id}>
                  <td className="fw-semibold">{req.employee}</td>
                  <td>{req.facility}</td>
                  <td>
                    <span
                      className={`badge rounded-pill px-3 py-2 ${getStatusClass(
                        req.status
                      )}`}
                    >
                      {req.status}
                    </span>
                  </td>
                  <td>
                    {req.status === "Pending" ? (
                      <div className="d-flex justify-content-center gap-2">
                        <button
                          className="btn btn-success btn-sm"
                          onClick={() => handleRecommend(req.id)}
                        >
                          <i className="bi bi-hand-thumbs-up me-1"></i> Recommend
                        </button>
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => handleReject(req.id)}
                        >
                          <i className="bi bi-x-circle me-1"></i> Reject
                        </button>
                      </div>
                    ) : (
                      <i className="bi bi-check-circle text-success fs-4"></i>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Reports Section */}
      <div className="card shadow-lg border-0 rounded-3">
        <div className="card-header bg-gradient bg-dark text-white fw-bold fs-5">
          📊 Facility Usage Reports (Team)
        </div>
        <div className="card-body">
          <table className="table table-striped table-bordered table-hover table-responsive align-middle text-center">
            <thead className="table-secondary">
              <tr>
                <th>Employee</th>
                <th>Facility</th>
                <th>Month</th>
                <th>Usage</th>
              </tr>
            </thead>
            <tbody>
              {reports.map((rep, index) => (
                <tr key={index}>
                  <td className="fw-semibold">{rep.employee}</td>
                  <td>{rep.facility}</td>
                  <td>{rep.month}</td>
                  <td className="text-success fw-bold">{rep.usage}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ManagerFacilities;
